//@flow
import {useDispatch} from 'react-redux';
import {useMemo} from 'react';
import {bindActionCreators} from 'redux';

export type Action = {
  [key: string]: *,
};

export type ActionCreator = (...args: any[]) => any;
export type ActionCreatorMap = {
  [key: string]: (...args: any[]) => any,
};

/**TODO: we should deprecate useActions as it doesn't rely on real action types */

export function useActions<T>(actions: Action): $Keys<T> {
  const dispatch = useDispatch();
  const bindedActionCreators = useMemo(
    () => bindActionCreators(actions, dispatch),
    [actions, dispatch]
  );
  return bindedActionCreators;
}

export function useBindedAction<T: ActionCreator>(action: T): T {
  const dispatch = useDispatch();

  const parsedActionCreatorMap = useMemo(() => ({action}), [action]);

  const bindedActionCreator = useMemo(
    () => bindActionCreators(parsedActionCreatorMap, dispatch),
    [dispatch, parsedActionCreatorMap]
  );

  return bindedActionCreator;
}
export function useBindedActions<T: ActionCreatorMap>(
  actions: T
): $ObjMap<T, <V>(V) => V> {
  const dispatch = useDispatch();
  const bindedActionCreatorMap = useMemo(
    () => bindActionCreators(actions, dispatch),
    [actions, dispatch]
  );
  return bindedActionCreatorMap;
}
